import * as React from "react";
const SvgFiRrTie = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17.844 15.873 15.04 6.001l.861-3.02A2.28 2.28 0 0 0 15.584.94a2.28 2.28 0 0 0-1.839-.939h-3.488c-.726 0-1.414.351-1.839.939a2.26 2.26 0 0 0-.329 2.002L8.961 6l-2.79 9.829a4 4 0 0 0 1.103 4.225l4.054 3.686a1 1 0 0 0 1.346 0l4.054-3.685c1.172-1.065 1.604-2.723 1.116-4.182M10.037 2.112a.26.26 0 0 1 .22-.112h3.487c.114 0 .182.061.22.112.036.051.073.134.025.281L13.245 5h-2.49l-.756-2.645a.26.26 0 0 1 .038-.243m5.344 16.463-3.38 3.074-3.383-3.074c-.585-.532-.802-1.361-.538-2.155l2.675-9.419h2.49l2.688 9.462a2 2 0 0 1-.552 2.112"
    />
  </svg>
);
export default SvgFiRrTie;
